import React from 'react';
import Button from 'react-bootstrap/Button';
import Translated from '../../Translated';
import { useUserData } from "../../../../context/UserDataContext";
import Alert from "react-bootstrap/Alert";
import CategorySelector from "./../../CategorySelector";


const SignsStart = (props) => {
  const { userSettings } = useUserData();

  const category = userSettings.vehicleCategory;
  if (category === null) {
    return <CategorySelector />;
  }

  const settingsData = userSettings.data;
  const settings = settingsData.categorySettings[category];
  const routeId = window.location.pathname.replace('/', '')
  const hasRouteDenyList = settings.routeDenyList !== null && settings.routeDenyList.length > 0;
  const isDeniedRoute = hasRouteDenyList && settings.routeDenyList.includes(routeId);

  if (isDeniedRoute) {
    return (
      <div>
        <Alert>
          <Translated translationKey="no_signs_for_category" />
        </Alert>
      </div>
    );
  } else {
    return (
      <div>
        <h3><Translated translationKey="signs_title" /></h3>
        <p>
          <Translated translationKey="signs_description" />
        </p>
        <p>
          <Button id="practise-signs-start" onClick={props.start}>
            <Translated translationKey="start" />
          </Button>
        </p>
      </div>
    );
  }
}

export default SignsStart;